import moment from 'jalali-moment'

const timezone = 'Asia/Tehran'
function parts(instant) {
  const result = {}
  new Intl.DateTimeFormat('en-GB', {
    timeZone: timezone, calendar: 'gregory', numberingSystem: 'latn', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date(instant)).forEach(part => { if (part.type !== 'literal') result[part.type] = Number(part.value) })
  return result
}
function timestamp(value) { return Date.UTC(value.year, value.month - 1, value.day, value.hour, value.minute, value.second || 0) }
export function tehranInput(iso) {
  if (!iso) return ''
  const value = parts(new Date(iso).getTime()); const pad = number => String(number).padStart(2, '0')
  return `${value.year}-${pad(value.month)}-${pad(value.day)}T${pad(value.hour)}:${pad(value.minute)}`
}
export function tehranUtc(input) {
  if (!input) return undefined
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(input)
  if (!match) throw new Error('INVALID_LOCAL_TIME')
  const value = {
    year: Number(match[1]), month: Number(match[2]), day: Number(match[3]), hour: Number(match[4]), minute: Number(match[5]), second: 0,
  }
  const nominal = timestamp(value); const check = new Date(nominal)
  if (check.getUTCFullYear() !== value.year || check.getUTCMonth() + 1 !== value.month || check.getUTCDate() !== value.day || check.getUTCHours() !== value.hour || check.getUTCMinutes() !== value.minute) throw new Error('INVALID_LOCAL_TIME')
  const offsets = [...new Set([-172800000, 0, 172800000].map(delta => timestamp(parts(nominal + delta)) - (nominal + delta)))]
  const candidates = offsets.map(offset => nominal - offset).filter(instant => timestamp(parts(instant)) === nominal)
  if (candidates.length !== 1) throw new Error('INVALID_LOCAL_TIME')
  return new Date(candidates[0]).toISOString()
}

export function normalizePickerTime(value) {
  if (!value) return ''
  return String(value).replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 1776)).replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 1632)).replace(' ', 'T')
}

function calendarPad(value) { return String(value).padStart(2, '0') }
export function jalaliInput(value) {
  if (!value || value === 'INVALID_JALALI_TIME') return ''
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value)
  if (!match) return ''
  const date = moment.jConvert.toJalali(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  return `${date.jy}/${calendarPad(date.jm + 1)}/${calendarPad(date.jd)} ${match[4]}:${match[5]}`
}
export function jalaliGregorian(value) {
  if (!value) return ''
  const normalized = normalizePickerTime(value).replace('T', ' ')
  const match = /^(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2})$/.exec(normalized)
  if (!match || Number(match[4]) > 23 || Number(match[5]) > 59 || Number(match[2]) < 1 || Number(match[2]) > 12 || Number(match[3]) < 1 || Number(match[3]) > 31) throw new Error('INVALID_JALALI_TIME')
  // Numeric conversion avoids global Moment locale and browser timezone changing calendar interpretation.
  const date = moment.jConvert.toGregorian(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  const gregorian = `${date.gy}-${calendarPad(date.gm + 1)}-${calendarPad(date.gd)}T${match[4]}:${match[5]}`
  if (jalaliInput(gregorian) !== normalized) throw new Error('INVALID_JALALI_TIME')
  return gregorian
}
